import { render, staticRenderFns } from "./BulkNotesModal.vue?vue&type=template&id=21290361&scoped=true"
import script from "./BulkNotesModal.vue?vue&type=script&lang=js"
export * from "./BulkNotesModal.vue?vue&type=script&lang=js"
import style0 from "./BulkNotesModal.vue?vue&type=style&index=0&id=21290361&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21290361",
  null
  
)

export default component.exports